/* eslint-disable jsx-a11y/anchor-is-valid */
import { Outlet, Route, Routes } from 'react-router-dom'
import { Error500 } from './components/Error500'
import { Error404 } from './components/Error404'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import { ErrorAuth } from './components/ErrorAuth'
import AccessDeniedPage from './components/AccessDeniedPage'

const ErrorsLayout = () => {

  const { config }: any = useSelector<RootState>(
    (state) => ({
      config: state.configuration.configurations,
    }),
    shallowEqual,
  )

  return (
    <div className='d-flex flex-column flex-root'>
      <div
        className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
        style={{ backgroundImage: `url('${toAbsoluteUrl('/media/illustrations/progress-hd.png')}')` }}
      >
        <div className='d-flex flex-column flex-column-fluid p-10'>
          <a href='/dashboard' className='mb-10'>
            <img src={config && config?.actual_logo} alt="" className='h-50px mb-5' />
          </a>
          <div className='pt-lg-10 mb-10 flex-grow-1'>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}

const ErrorsPage = () => (
  <Routes>
    <Route path='auth' element={<ErrorAuth />} />
    <Route element={<ErrorsLayout />}>
      <Route path='404' element={<Error404 />} />
      <Route path='500' element={<Error500 />} />
      <Route path='access-denied' element={<AccessDeniedPage />} />
      <Route index element={<Error404 />} />
    </Route>
  </Routes>
)

export { ErrorsPage }
